import { HttpResponse } from "./HttpResponse";


export class EmailSender
{
    private serverUrl = "https://email.specteam.pl";

    public async SendEmail(targetEmail: string, subject: string, message: string): Promise<boolean>
    {
        try
        {
            if (!targetEmail?.trim())
            {
                throw new Error(`No email address provided`);
            }

            const postPackage = {
                Target: targetEmail.trim(),
                Subject: subject,
                Message: message
            };

            const result = await this.PostJSON(postPackage);
           
            return result.data == "SENT";
        }
        catch (ex: any)
        {
            return false;
        }
    }

    private async PostJSON(data: any): Promise<HttpResponse>
    {
        const httpResponse = new HttpResponse();
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: dataAsString,
        });

        httpResponse.status = response.status;
        const json = await response.text();
        httpResponse.data = json;
        return httpResponse;
    }
}
